const TOKEN_STORAGE_KEY = 'token';
const USER_STORAGE_KEY = 'user';

export const getStoredAuthToken = () => {
  return sessionStorage.getItem(TOKEN_STORAGE_KEY) || '';
};

export const getStoredAuthUser = () => {
  return '';
};

export const migrateLegacyAuthSession = () => {
  const legacyToken = localStorage.getItem(TOKEN_STORAGE_KEY);

  if (legacyToken && !sessionStorage.getItem(TOKEN_STORAGE_KEY)) {
    sessionStorage.setItem(TOKEN_STORAGE_KEY, legacyToken);
  }

  if (legacyToken || localStorage.getItem(USER_STORAGE_KEY) || sessionStorage.getItem(USER_STORAGE_KEY)) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(USER_STORAGE_KEY);
    sessionStorage.removeItem(USER_STORAGE_KEY);
  }

  return {
    token: getStoredAuthToken(),
    user: '',
  };
};

export const storeAuthSession = ({ token, user } = {}) => {
  if (typeof token === 'string') {
    if (token) {
      sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
    } else {
      sessionStorage.removeItem(TOKEN_STORAGE_KEY);
    }
  }

  if (user !== undefined) {
    sessionStorage.removeItem(USER_STORAGE_KEY);
    localStorage.removeItem(USER_STORAGE_KEY);
  }
};

export const buildAuthHeaders = (extraHeaders = {}) => {
  const token = getStoredAuthToken();
  return token
    ? { Authorization: `Bearer ${token}`, ...extraHeaders }
    : { ...extraHeaders };
};

export const clearStoredAuthToken = () => {
  sessionStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(TOKEN_STORAGE_KEY);
};

export const clearStoredAuthSession = () => {
  clearStoredAuthToken();
  sessionStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);
};